import { createStore } from 'redux'
import { combineReducers } from 'redux'; 
import user from '../../services/reducers/reducer' 
const rootReducer = combineReducers({
    user
});
export default createStore(rootReducer)